import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
  state: {
    directories: [],
    directory: null,
  },
  getters,
  mutations,
  actions,
};
